<template>
  <edit-rule
    v-if="selectedDomain.id"
    :tier="tierType"
    :id="selectedDomain.id"
  />
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import EditRule from "@/views/Common/GeoBlocking/Rules/Edit/index.vue";

import { TIER } from "@/constants";

export default {
  name: "GeoblockingRuleEditWrap",
  components: {
    EditRule,
  },
  data() {
    return {
      tierType: TIER.domains,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedDomain"]),
  },
  created() {
    this.setPageTitle(this.$t("Geoblocking"));
    this.setPageSubtitle([]);
  },
};
</script>
